import { IOnInit } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import { IGridSettings } from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { ProcessGroup, ProcessInformation } from "../../model/ProcessGroups";
import {
  UserProfile,
  vsName as UserProfileName,
} from "../../../application/UserProfile";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import { processInstancesName } from "../../config/objects";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";

export interface ProcessSelectedArgs {
  processViewController: ProcessViewController;
  processInformation: ProcessInformation;
}

export class ProcessViewController implements IOnInit {
  gridDataSource!: RecordDataSource;
  columns!: ColDef[];

  createProcesses: ProcessInformation[] = [];

  readonly gridSettings!: IGridSettings;
  readonly processGroup!: ProcessGroup;
  readonly defaultQuery!: IQuery;
  readonly additionalGridColumns!: ColDef[];

  static $inject = [
    ServerUtilityName,
    UserProfileName,
    RecordGridViewServiceName,
    ColumnDefinitionServiceName,
  ];

  constructor(
    private readonly serverUtility: ServerUtility,
    private readonly userProfile: UserProfile,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly columnDefinitionService: ColumnDefinitionService
  ) {}

  $onInit(): void {
    this.createProcesses = this.userProfile.hasPermission(
      this.processGroup.CreatePermission
    )
      ? this.processGroup.ProcessInformation
      : [];

    this.gridDataSource = new RecordDataSource(
      this.serverUtility,
      `/api${this.processGroup.Url}`
    );

    this.columns = this.getColumns();
  }

  private getColumns() {
    const gridConfiguration =
      this.recordGridViewService.getGridConfiguration(processInstancesName);
    const processColumns = gridConfiguration?.columns ?? [];

    const fieldNames = new Set<string>(processColumns.map((c) => c.field!));
    const additionalGridColumns = this.additionalGridColumns.filter(
      (c) => !fieldNames.has(c.field!)
    );

    return [
      this.columnDefinitionService.getLinkColDef({
        headerName: "info",
        iconClass: "fa fa-info-circle text-primary",
        colId: "detail",
        width: 20,
        stateExpression: ".detail({  processInstancesId: data.Id })",
      }),
      ...processColumns,
      ...additionalGridColumns,
    ];
  }
}
